import { MedigapPlanName } from '@coverright/data-access/types/medigap';

export enum PlanCategory {
  MostPopular = 'Most Popular',
  CoreBenefits = 'Core benefits',
  //  Comprehensive = 'Comprehensive',
  CostShare = 'Cost-share',
  HighDeductible = 'High deductible',
}

export type PlanCategoryDescription = {
  name: PlanCategory;
  plans: MedigapPlanName[];
};

export const planCategories: PlanCategoryDescription[] = [
  {
    name: PlanCategory.MostPopular,
    plans: [MedigapPlanName.F, MedigapPlanName.G, MedigapPlanName.N],
  },
  //  {name: PlanCategory.Comprehensive, plans: [MedigapPlanName.C, MedigapPlanName.D, MedigapPlanName.F, MedigapPlanName.G]},
  {
    name: PlanCategory.HighDeductible,
    plans: [MedigapPlanName.Hdf, MedigapPlanName.Hdg],
  },
  {name: PlanCategory.CostShare, plans: [MedigapPlanName.K, MedigapPlanName.L, MedigapPlanName.M]},
  {
    name: PlanCategory.CoreBenefits,
    plans: [MedigapPlanName.A, MedigapPlanName.B],
  },
];
